import React, { useState } from 'react';
const API_URL = process.env.REACT_APP_API_URL;

function AddItemForm(props) {
    // State to hold the input value and status
    const [name, setName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    // Handle input change
    const handleInputChange = (e) => {
        setName(e.target.value);
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Create the object to send
        const newItem = {
            name: name
        };

        try {
            setIsLoading(true);
            setError(null);
            setSuccess(null);

            // Make API call using fetch (replace URL with your actual API endpoint)
            const response = await fetch(`${API_URL}/${props.endpoint}/add`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newItem),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            setSuccess('Item added successfully!');
            setName(''); // Clear the input after successful submission
            console.log('Response:', data);

        } catch (err) {
            setError('Failed to add item. Please try again.');
            console.error('Error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="name">Name:</label>
                    <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={handleInputChange}
                        placeholder="Enter name"
                        required
                    />
                </div>
                <button type="submit" disabled={isLoading}>
                    {isLoading ? 'Adding...' : 'Add Item'}
                </button>
            </form>

            {/* Display success or error messages */}
            {success && <p style={{ color: 'green' }}>{success}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
}

export default AddItemForm;